<template>
  <div>
    <page-header
      icon="mdi-account-group"
      :title="$t('users')"
      :subtitle="`${restaurantName} #${companyId}`"
      icon-color="primary"
    >
      <template #actions>
        <v-chip label color="info" small>
          <v-icon left small>mdi-account</v-icon>
          {{ employees.length }} {{ $t("users_lowercase") }}
        </v-chip>
      </template>
    </page-header>
    <!-- Employee Toolbar -->
    <employee-toolbar
      :restaurant-name="restaurantName"
      v-model="search"
      :company-children.sync="companyChildren"
      :children-companies="childrenCompanies"
      :company="company"
      :visible-employees="visibleEmployees"
      :parent-company="parentCompany"
      :show-credit-column="showCreditColumn"
      @company-filter-changed="addUsersToParentCompany"
      @toggle-all-companies="addAllUsersToParent"
      @add-employee="dialog = true"
      @add-multiple-employees="addMultiple = true"
      @import-excel="dialogImport = true"
      @search-user="openModalSearchUser = true"
    />

    <div class="px-6 mt-2">
      <!-- Employee Table -->
      <employee-table
        :employees="employees"
        :search.sync="search"
        :loading="loading"
        :company="company"
        :select-all-time-limit="selectAllTimeLimit"
        :show-credit-column="showCreditColumn"
        :show-office-column="companyChildren.length > 0"
        @openUserReport="openUserReport($event)"
        @current-items="visibleEmployees = $event"
        @toggle-all-time-limit="toggleAllTimeLimit"
        @user-can-see-menu="userCanSeeMenu"
        @set-can-report="setCanReport"
        @set-time-limit="setTimeLimit"
        @create-table-qr="createTableQr"
        @show-employee-qr="
          employeeQrDialogData = $event;
          employeeQrDialog = true;
        "
        @edit-item="editItem"
        @delete-item="deleteItem"
        @open-credit2="openCredit2"
      />
    </div>
    <company-employee-qr-dialog
      v-model="employeeQrDialog"
      :employee="employeeQrDialogData"
    />
    <company-menu-options-dialog
      v-model="dialogCanSeeMenu"
      :employee="menuOptionsEmployee"
      :podesavanja="podesavanja"
    />
    <company-employee-credit-dialog2
      v-if="dialogCredit2"
      v-model="dialogCredit2"
      :employee="modalCreditUser"
      :parent-companies="parentCompanies"
      @close="dialogCredit2 = false"
    />
    <company-employee-search-dialog v-model="openModalSearchUser" />
    <company-employee-quick-add-dialog
      v-model="addMultiple"
      :restaurant-name="restaurantName"
      :parent-company="parentCompany"
      :parent-companies="parentCompanies"
      :selected-company="selectedCompany"
      @employeeAdded="employees.push($event)"
    />
    <company-employee-activate-qr-dialog v-model="dialogTableQr" :employee="editedItem" />

    <company-employee-dialog
      v-model="dialog"
      :employee="editedItem"
      :parent-companies="parentCompanies"
      :companies="companies"
      :selected-company="selectedCompany"
      @employeeAdded="employeeAdded"
      @employeeUpdated="employeeUpdated"
      @companyUpdated="companyUpdated"
    />
    <global-confirm-box ref="confirmBox" />
    <report-employee-order-history-dialog-group
      v-if="userReport.company && userReport.company.type === 'group'"
      v-model="userReport.dialog"
      :company="userReport.company"
      :employee="userReport.employee"
    />
    <report-employee-order-history-dialog
      v-else
      v-model="userReport.dialog"
      :company="userReport.company"
      :employee="userReport.employee"
    />
    <ImportExcel v-model="dialogImport" @import-completed="onImportCompleted" />
  </div>
</template>

<script>
import PageHeader from "@/components/global/PageHeader.vue";
import CompanyEmployeeQrDialog from "@/components/company/employee/dialogs/CompanyEmployeeQrDialog.vue";
import CompanyEmployeeActivateQrDialog from "@/components/company/employee/dialogs/CompanyEmployeeActivateQrDialog.vue";
import CompanyMenuOptionsDialog from "@/components/company/dialogs/CompanyMenuOptionsDialog.vue";
import CompanyEmployeeDialog from "@/components/company/employee/dialogs/CompanyEmployeeDialog.vue";
import CompanyEmployeeCreditDialog2 from "@/components/company/employee/dialogs/CompanyEmployeeCreditDialog2.vue";
import CompanyEmployeeSearchDialog from "@/components/company/employee/dialogs/CompanyEmployeeSearchDialog.vue";
import CompanyEmployeeQuickAddDialog from "@/components/company/employee/dialogs/CompanyEmployeeQuickAddDialog.vue";
import ReportEmployeeOrderHistoryDialogGroup from "@/components/report/employee/dialogs/ReportEmployeeOrderHistoryDialog.vue";
import ReportEmployeeOrderHistoryDialog from "@/components/report/employee/dialogs/ReportEmployeeMealOrderHistoryDialog.vue";
import EmployeeToolbar from "@/components/company/employee/EmployeeToolbar.vue";
import EmployeeTable from "@/components/company/employee/EmployeeTable.vue";
import { defaultEmployee } from "@/models/employee";
import employeeService from "@/services/employee";
import hasSnackbar from "@/mixins/hasSnackbar";
import ImportExcel from "@/components/import-excel.vue";

export default {
  mixins: [hasSnackbar],
  components: {
    ImportExcel,
    CompanyEmployeeQrDialog,
    CompanyEmployeeActivateQrDialog,
    CompanyMenuOptionsDialog,
    CompanyEmployeeDialog,
    CompanyEmployeeCreditDialog2,
    CompanyEmployeeSearchDialog,
    CompanyEmployeeQuickAddDialog,
    EmployeeToolbar,
    EmployeeTable,
    ReportEmployeeOrderHistoryDialog,
    ReportEmployeeOrderHistoryDialogGroup,
    PageHeader,
  },
  data: () => ({
    // Dialog state 
    dialog: false,
    dialogTableQr: false,
    dialogImport: false,
    dialogCanSeeMenu: false,
    dialogCredit2: false,
    employeeQrDialog: false,
    addMultiple: false,
    openModalSearchUser: false,

    // UI state
    loading: false,
    search: "",
    visibleEmployees: [],
    selectAllTimeLimit: 1,
    showCreditColumn: false,

    // Employee data
    employees: [],
    usersOriginal: [],
    editedItem: { ...defaultEmployee },
    menuOptionsEmployee: null,
    employeeQrDialogData: null,
    modalCreditUser: {},

    // Company data
    companies: [],
    parentCompanies: [],
    company: null,
    companyChildren: [],
    childrenCompanies: [],
    restaurantName: "",

    // Settings per employee
    podesavanja: [],
    userMenuRestaurant: [],

    userReport: {
      dialog: false,
      employee: null,
      company: null,
    },
  }),
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companyId() {
      return this.$route.params.id || this.$store.state.company.id;
    },
    selectedCompany() {
      return this.companies.find((company) => company.id === Number(this.companyId));
    },
    parentCompany() {
      return this.companies.find((company) =>
        (company.children || []).some(
          (subcompany) => subcompany.id === Number(this.companyId)
        )
      );
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, defaultEmployee);
        });
      }
    },
    visibleEmployees: {
      handler() {
        // Update the master checkbox state based on visible employees
        this.updateSelectAllTimeLimitState();
      },
      deep: true,
    },
  },

  created() {
    this.initialize();
    this.getParentCompanies();
    this.getCompanies();
  },

  methods: {
    openUserReport(item) {
      this.userReport.employee = item.employee;
      this.userReport.company = item.company;
      this.userReport.dialog = true;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedItem.company_id = this.companyId;

      this.editedItem.all_cooperation =
        this.editedItem.company && this.editedItem.company.settings
          ? this.editedItem.company.settings.all_cooperation
          : "";
      if (this.companies) {
        this.companies.filter((items) => {
          if (
            items.id == item.company
              ? parseInt(item.company.id)
              : parseInt(item.company_id)
          ) {
            this.editedItem.children = items.children;
          }
        });
      }

      this.dialog = true;
    },
    employeeAdded(employee) {
      this.employees.unshift(employee);
    },
    employeeUpdated() {
      const index = this.employees.findIndex((item) => {
        return item.id == this.editedItem.id;
      });
      Object.assign(this.employees[index], this.editedItem);
    },
    companyUpdated() {
      this.employees.filter((item, index) => {
        if (item.id == this.editedItem.id) {
          this.employees.splice(index, 1);
        }
      });
    },
    userCanSeeMenu(item, index) {
      this.menuOptionsEmployee = item;
      this.dialogCanSeeMenu = true;
    },
    addUsersToParentCompany() {
      if (this.companyChildren.length > 0) {
        const users = [];
        this.parentCompanies.forEach((item) => {
          if (item.users && item.users.length > 0) {
            item.users.forEach((user) => {
              if (this.companyChildren.includes(user.pivot.company_id)) {
                users.push(user);
              }
            });
          }
        });
        this.employees = users;
      } else {
        this.employees = this.usersOriginal;
      }
    },
    addAllUsersToParent() {
      if (this.companyChildren.length > 0) {
        this.companyChildren = [];
        this.addUsersToParentCompany();
      } else if (this.companyChildren.length == 0) {
        let allFirmsId = [];
        this.parentCompanies.filter((firm) => {
          allFirmsId.push(firm.id);
        });
        this.companyChildren = allFirmsId;
        this.addUsersToParentCompany();
      }
    },
    getParentCompanies() {
      employeeService
        .getParentCompanies(this.companyId)
        .then(({ data }) => {
          if (!data) {
            this.parentCompanies = [];
            return;
          }
          this.parentCompanies = data.map((company) => {
            return {
              ...company,
              users: (company.users || []).map((user) => ({
                ...user,
                company,
              })),
            };
          });
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_parent_companies"));
        });
    },
    createTableQr(user) {
      this.dialogTableQr = true;
      this.editedItem = Object.assign({}, user);
    },
    setTimeLimit(item, index) {
      employeeService
        .setTimeLimit(item)
        .then(() => {
          this.showSuccessSnackbar(this.$t("time_limit_updated"));
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("time_limit_update_failed"));
        })
        .finally(() => {
          // Update the master checkbox state after individual change
          this.$nextTick(() => {
            this.updateSelectAllTimeLimitState();
          });
        });
    },
    toggleAllTimeLimit(isSelectedAll) {
      // Get currently visible employees from the data table
      const currentVisibleEmployees = this.visibleEmployees || [];

      // Update all visible employees' time_limit based on the master checkbox
      const promises = currentVisibleEmployees
        .map((employee) => {
          if (employee.no_time_limit_user !== undefined) {
            employee.no_time_limit_user = isSelectedAll ? 1 : 0;
            // Call the API to update each employee
            return employeeService.setTimeLimit(employee).then((response) => {
              const index = this.employees.findIndex((emp) => emp.id === employee.id);
              if (index !== -1) {
                this.employees[index].no_time_limit_user =
                  response.data.data?.no_time_limit_user;
              }
            });
          }
        })
        .filter(Boolean);

      Promise.all(promises)
        .then(() => {
          this.showSuccessSnackbar(this.$t("all_time_limits_updated"));
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("time_limits_update_failed"));
        });
    },
    updateSelectAllTimeLimitState() {
      const currentVisibleEmployees = this.visibleEmployees || [];
      this.selectAllTimeLimit = currentVisibleEmployees.every(
        (emp) => emp.no_time_limit_user === 1
      )
        ? 1
        : 0;
    },
    openCredit2(item) {
      this.dialogCredit2 = true;
      this.modalCreditUser = {
        ...item,
        kredit: item.credit?.duguje || "",
      };
    },
    setCanReport(item, index, value) {
      const data = {
        settings: this.podesavanja[index],
        user: {
          ...item,
          can_report: value,
        },
      };
      employeeService
        .setCanReport(data)
        .then(() => {
          this.showSuccessSnackbar(this.$t("report_access_updated"));
          item.can_report = value;
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("report_access_update_failed"));
        });
    },
    getCompanies() {
      const companyId = Number(
        this.$route.params?.id || this.$store.state.company?.id || 0
      );

      if (this.user.type === "company") {
        employeeService
          .getParentCompanies(companyId)
          .then((res) => {
            this.childrenCompanies = res.data;
          })
          .catch(() => {
            this.showErrorSnackbar(this.$t("error_loading_companies"));
          });
      } else if (this.user.type != "admin_delivery") {
        employeeService
          .getCompanies()
          .then((res) => {
            this.companies = res.data;
            const company = this.companies.find((c) => c.id === companyId);
            this.childrenCompanies = company ? [company, ...company.children] : [];
          })
          .catch(() => {
            this.showErrorSnackbar(this.$t("error_loading_companies"));
          });
      }
    },
    initialize() {
      // Determine which fetch method to use based on the route
      let fetchUsersPromise;

      if (this.$route.name === "korisnici" || this.$route.name === "firma-id-korisnici") {
        if (this.$route.params.delivery === "dostava") {
          fetchUsersPromise = employeeService.getCompanyUsersDelivery(this.companyId);
        } else {
          fetchUsersPromise = employeeService.getCompanyUsers(this.companyId);
        }
      } else if (this.$route.name === "restoran-id-korisnici") {
        const restaurantId = this.companyId;
        if (this.$route.params.delivery === "dostava") {
          fetchUsersPromise = employeeService.getRestaurantUsersDelivery(restaurantId);
        } else {
          fetchUsersPromise = employeeService.getRestaurantUsers(restaurantId);
        }
      }

      // Fetch users and update component state
      if (fetchUsersPromise) {
        this.loading = true;
        fetchUsersPromise
          .then((res) => {
            this.company = res.data;
            this.restaurantName = res.data.name;
            this.employees = res.data.users;
            this.usersOriginal = res.data.users;

            // Set flag for credit column visibility
            this.showCreditColumn = res.data.is_credit || false;

            // Store additional settings for each employee
            this.employees.forEach((employee, index) => {
              this.podesavanja[index] = employee.pivot.settings;
              this.userMenuRestaurant[employee.id] = employee.pivot.add_restoran;
            });
          })
          .catch(() => {
            this.showErrorSnackbar(this.$t("error_loading_employees"));
          })
          .finally(() => {
            this.loading = false;
            // Update master checkbox state after data is loaded
            this.$nextTick(() => {
              this.updateSelectAllTimeLimitState();
            });
          });
      }
    },
    deleteItem(item) {
      this.$refs.confirmBox
        .open(
          this.$t("delete"),
          `${this.$t("delete_confirmation")}: ${[
            this.toLatin(item.name),
            this.toLatin(item.lastname),
          ].join(" ")}`,
          {
            color: "error",
          }
        )
        .then(() => {
          employeeService
            .deleteUser(item.id)
            .then(() => {
              const index = this.employees.findIndex(
                (employee) => employee.id === item.id
              );
              this.employees.splice(index, 1);
              this.showSuccessSnackbar(this.$t("employee_deleted"));
            })
            .catch(() => {
              this.showErrorSnackbar(this.$t("employee_delete_failed"));
            });
        })
        .catch((err) => console.warn(err));
    },
    onImportCompleted() {
      // Reload users after import is completed
      this.initialize();
    },
  },
};
</script>
